import { Icon } from '@hai/ui-react';
import { IIconProps } from '@hai/ui-react/dist/icons/Icon';
import React from 'react';

interface ToggleIconButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  activeIconName: string;
  inactiveIconName: string;
  isActive: boolean;
  onToggle: (isActive: boolean) => void;
  disabled?: boolean;
  size?: IIconProps['size'];
}

export const AWToggleIconButton: React.FC<ToggleIconButtonProps> = ({
  activeIconName,
  inactiveIconName,
  isActive,
  onToggle,
  disabled = false,
  size = 'sm3',
  className,
  ...otherParams
}) => {
  return (
    <button
      onClick={() => {
        onToggle(!isActive);
      }}
      className={`aw-toggle-icon-button${className ? ` ${className}` : ''}`}
      disabled={disabled}
      {...otherParams}
    >
      <Icon iconname={isActive ? activeIconName : inactiveIconName} size={size} />
    </button>
  );
};
